/**
 * author andre.pitombeira
 */
export default function appConfig(
  $controllerProvider,
  $compileProvider,
  $filterProvider,
  $provide,
  $sceDelegateProvider,
  $httpProvider,
  $translateProvider
) {
  // lazy controller, directive and service
  var body = window.document.body,
    dataset = body.dataset,
    prefixDomain = (dataset && dataset['app-cdn']) || body.getAttribute('data-app-cdn') || '/'; // jshint -W069

  // NEW RELIC exception handler
  $provide.decorator('$exceptionHandler', function($delegate) {
    return function(exception, cause) {
      $delegate(exception, cause);
      if (angular.isDefined(window.NREUM)) {
        window.NREUM.noticeError(exception);
      }
    };
  });

  $sceDelegateProvider.resourceUrlWhitelist(['self', prefixDomain + '**', 'https://d6zktcp1soofu.cloudfront.net/**']);

  //headers to prevent browsers return 304 (from cache)
  if (!$httpProvider.defaults.headers.get) {
    $httpProvider.defaults.headers.get = {};
  }

  $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
  $httpProvider.defaults.headers.get['Pragma'] = 'no-cache';

  //Add blob as a valid href to the default list
  $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|tel|file|blob):/);
  $compileProvider.debugInfoEnabled(false);
  $httpProvider.interceptors.push('apiInterceptor');
  $httpProvider.interceptors.push('AuthenticationInterceptor');
  $httpProvider.interceptors.push('LoadingInterceptor');
  $httpProvider.interceptors.push('NotificationInterceptor');

  // angular translate
  $translateProvider.useStaticFilesLoader({
    prefix: prefixDomain + 'environment/lang/',
    suffix: '.json',
  });
}



// WEBPACK FOOTER //
// ./src/app/app.config.js